<template>
  <div>
    <!-- <div class="hidden md:block min-h-screen bg-gray-100"> -->
    <div class="min-h-screen bg-gray-100">
      <slot></slot>

      <toast></toast>
    </div>
    <!-- <div class="md:hidden">
      <p class="p-12">Markencode App ist (noch) nicht für kleine Screens optimiert.</p>
    </div> -->
  </div>
</template>

<script>
import Toast from '@/Shared/Toast';

export default {
  components: {
    Toast
  }
};
</script>
